import { el } from 'redom';

import TextInput from './';

class TextInputBox {

  constructor(configuration) {

    this.errored = false;

    this.input = new TextInput(configuration);

    this.error = this.renderError();

    this.el = el('.field-input-and-error', {
      class: configuration.boxClass || '',
    }, [
      this.input,
      this.error
    ]);

  }

  renderError() {

    return el('label.error-message');

  }

  setValue(value) {

    this.input.setValue(value);

  }

  setError(errorMessage) {

    this.errored = true;

    this.error.textContent = errorMessage;

  }

  clearError() {

    if (this.errored === false) {
      return;
    }

    this.errored = false;

    this.error.textContent = '';

  }

  empty() {

    this.setValue('');

  }

  reset() {

    this.empty();
    this.clearError();

  }

  getValue() {

    return this.input.getValue();

  }

  focus() {

    this.input.focus();

  }

  disable() {

    this.input.disable();

  }

  enable() {

    this.input.enable();

  }

  setAttr(attributes) {

    this.input.setAttr(attributes);

  }

  setReadOnly(readOnly) {

    this.input.setReadOnly(readOnly);

  }

  hide() {

    this.el.classList.add('hidden');

  }

  show() {

    this.el.classList.remove('hidden');

  }

}

export default TextInputBox;